import { IconContent } from '@icons';

export const arrowLeft: IconContent = {
    sm: '<path d="m2 8 4.293 4.293.707-.707L3.914 8.5H13.5v-1H3.914L7 4.414l-.707-.707L2 8Z" />',
};
